import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ArrayHelper {
    public group(items: any[], by: (item: any, index: number) => any, map: ((item: any) => any) | undefined) {
        let index = 0;
        return items.reduce((result, item) => {
            (result[by(item, index)] = result[by(item, index++)] || []).push(map ? map(item) : item);
            return result;
        }, {});
    }
}
